import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/shared/services/base.service";
import { CreateTranslationResponse, TransalationContentPayload, TranslationContentResponse, TranslationPayload, TranslationSetResponse } from "./translation.type";

@Injectable({
  providedIn: 'root'
})
export class TranslationHttpService extends BaseService {
  constructor(
    httpClient: HttpClient
  ) {
    super(httpClient)
  }

  translationText(payload: TransalationContentPayload): Observable<TranslationContentResponse> {
    const uri = `translation/translate`;
    return this.post<TranslationContentResponse, TransalationContentPayload>(uri, payload);
  }

  createTranslation(payload: TranslationPayload): Observable<CreateTranslationResponse> {
    const uri = `translation/create`;
    return this.post<CreateTranslationResponse, TranslationPayload>(uri, payload);
  }
  
  getTranslation(id: string): Observable<TranslationSetResponse> {
    const uri = `translation/${id}`;
    return this.get<TranslationSetResponse>(uri);
  }
}